var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-tab"},[_c('router-link',{attrs:{"to":_vm.route}},[_vm._t("default"),(_vm.badge)?_c('div',{staticClass:"e-tab_badge"},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }